import React, { useState } from "react";
import './App.css';
import { useNavigate } from "react-router-dom";
import logo from './logo.svg';
import rupee from './rupee.svg';

export default function Welcomehome()
{
    const navigate = useNavigate();
    return (
        <div className="App" onAnimationEnd={()=>{navigate('/login')}}>
          <header className="App-header">
            <img src={rupee} className="App-logo" alt="rupee" />
            <p>
              Finance Assitant
            </p>
            
          </header>
        </div>
      );
    
    
}